/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SpecialistSupportRouteImport } from './routes/specialist-support'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as PaymentAssistanceRouteImport } from './routes/payment-assistance'
import { Route as OutagesRouteImport } from './routes/outages'
import { Route as OnlineSafetyRouteImport } from './routes/online-safety'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as FaqsRouteImport } from './routes/faqs'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CisRouteImport } from './routes/cis'
import { Route as IndexRouteImport } from './routes/index'

const SpecialistSupportRoute = SpecialistSupportRouteImport.update({
  id: '/specialist-support',
  path: '/specialist-support',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentAssistanceRoute = PaymentAssistanceRouteImport.update({
  id: '/payment-assistance',
  path: '/payment-assistance',
  getParentRoute: () => rootRouteImport,
} as any)
const OutagesRoute = OutagesRouteImport.update({
  id: '/outages',
  path: '/outages',
  getParentRoute: () => rootRouteImport,
} as any)
const OnlineSafetyRoute = OnlineSafetyRouteImport.update({
  id: '/online-safety',
  path: '/online-safety',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqsRoute = FaqsRouteImport.update({
  id: '/faqs',
  path: '/faqs',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const CisRoute = CisRouteImport.update({
  id: '/cis',
  path: '/cis',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/cis': typeof CisRoute
  '/contact': typeof ContactRoute
  '/faqs': typeof FaqsRoute
  '/legal': typeof LegalRoute
  '/online-safety': typeof OnlineSafetyRoute
  '/outages': typeof OutagesRoute
  '/payment-assistance': typeof PaymentAssistanceRoute
  '/sign-up': typeof SignUpRoute
  '/specialist-support': typeof SpecialistSupportRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cis': typeof CisRoute
  '/contact': typeof ContactRoute
  '/faqs': typeof FaqsRoute
  '/legal': typeof LegalRoute
  '/online-safety': typeof OnlineSafetyRoute
  '/outages': typeof OutagesRoute
  '/payment-assistance': typeof PaymentAssistanceRoute
  '/sign-up': typeof SignUpRoute
  '/specialist-support': typeof SpecialistSupportRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/cis': typeof CisRoute
  '/contact': typeof ContactRoute
  '/faqs': typeof FaqsRoute
  '/legal': typeof LegalRoute
  '/online-safety': typeof OnlineSafetyRoute
  '/outages': typeof OutagesRoute
  '/payment-assistance': typeof PaymentAssistanceRoute
  '/sign-up': typeof SignUpRoute
  '/specialist-support': typeof SpecialistSupportRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cis'
    | '/contact'
    | '/faqs'
    | '/legal'
    | '/online-safety'
    | '/outages'
    | '/payment-assistance'
    | '/sign-up'
    | '/specialist-support'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cis'
    | '/contact'
    | '/faqs'
    | '/legal'
    | '/online-safety'
    | '/outages'
    | '/payment-assistance'
    | '/sign-up'
    | '/specialist-support'
  id:
    | '__root__'
    | '/'
    | '/cis'
    | '/contact'
    | '/faqs'
    | '/legal'
    | '/online-safety'
    | '/outages'
    | '/payment-assistance'
    | '/sign-up'
    | '/specialist-support'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CisRoute: typeof CisRoute
  ContactRoute: typeof ContactRoute
  FaqsRoute: typeof FaqsRoute
  LegalRoute: typeof LegalRoute
  OnlineSafetyRoute: typeof OnlineSafetyRoute
  OutagesRoute: typeof OutagesRoute
  PaymentAssistanceRoute: typeof PaymentAssistanceRoute
  SignUpRoute: typeof SignUpRoute
  SpecialistSupportRoute: typeof SpecialistSupportRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/specialist-support': {
      id: '/specialist-support'
      path: '/specialist-support'
      fullPath: '/specialist-support'
      preLoaderRoute: typeof SpecialistSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-assistance': {
      id: '/payment-assistance'
      path: '/payment-assistance'
      fullPath: '/payment-assistance'
      preLoaderRoute: typeof PaymentAssistanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/outages': {
      id: '/outages'
      path: '/outages'
      fullPath: '/outages'
      preLoaderRoute: typeof OutagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/online-safety': {
      id: '/online-safety'
      path: '/online-safety'
      fullPath: '/online-safety'
      preLoaderRoute: typeof OnlineSafetyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faqs': {
      id: '/faqs'
      path: '/faqs'
      fullPath: '/faqs'
      preLoaderRoute: typeof FaqsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cis': {
      id: '/cis'
      path: '/cis'
      fullPath: '/cis'
      preLoaderRoute: typeof CisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CisRoute: CisRoute,
  ContactRoute: ContactRoute,
  FaqsRoute: FaqsRoute,
  LegalRoute: LegalRoute,
  OnlineSafetyRoute: OnlineSafetyRoute,
  OutagesRoute: OutagesRoute,
  PaymentAssistanceRoute: PaymentAssistanceRoute,
  SignUpRoute: SignUpRoute,
  SpecialistSupportRoute: SpecialistSupportRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
